import { useRef, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { Upload } from 'react-bootstrap-icons'
import { t } from '../locale'

export default function FileUploader({
  clientId,
  firmename,
  onUploadSuccess,
}: {
  clientId: string | null
  firmename: string | null
  onUploadSuccess?: () => void
}) {
  const [loading, setLoading] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

    const formData = new FormData()
    if (clientId) formData.append('clientId', clientId)
    if (firmename) formData.append('firmename', firmename)
    formData.append('type', 'ds-sign')
    formData.append('file', file)

    try {
      setLoading(true)
      const res = await fetch(`${process.env.REACT_APP_API_URL}/files/kyc/upload`, {
        method: 'POST',
        body: formData,
      })
      if (!res.ok) throw new Error()
      onUploadSuccess?.()
    } catch {
      alert('Greška prilikom uploada')
    } finally {
      setLoading(false)
      if (inputRef.current) inputRef.current.value = ''
    }
  }

  return (
    <>
      <input ref={inputRef} type='file' className='d-none' onChange={handleFileChange} />
      <button
        className='btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1'
        onClick={() => inputRef.current?.click()}
        disabled={loading}
      >
        {loading ? <Spinner size='sm' animation='border' /> : <Upload />}
        <span>{loading ? '...' : t('upload')}</span>
      </button>
    </>
  )
}
